import { ImmutableStore } from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';
import moment from 'moment';
import { GuideDelivery } from '../model/Guide';
import { startOfDay, zeroDate } from '../utils/Date';

export function generateAllowedDateRange() {
  return {
    start: startOfDay().subtract(2, 'year').toDate(),
    end: zeroDate(moment(), true).toDate()
  };
}

const defaultState = {
  histogram: [],
  guideDelivery: GuideDelivery.both,
  allowedDateRange: generateAllowedDateRange(),
  loaded: false
};

class HistogramStore extends ImmutableStore {
  static storeName = 'HistogramStore';

  static handlers = {
    [Actions.HISTOGRAM__DATA_LOADED]: 'handleHistogramDataChanged'
  };

  constructor(dispatcher) {
    super(dispatcher);

    this.setState(defaultState);
  }

  handleHistogramDataChanged({histogram, guideDelivery, allowedDateRange}) {
    const state = {};
    if (histogram) {
      histogram.forEach(d => {
        d.timestamp = moment().isoWeekYear(d.year).isoWeek(d.week).isoWeekday(1).toDate();
      });
      state.histogram = histogram;
      state.loaded = true;
    }

    if (allowedDateRange) {
      state.allowedDateRange = allowedDateRange;
    }

    if (guideDelivery) {
      state.guideDelivery = guideDelivery;
    }

    this.mergeState(state);
  }

  getHistogramData() {
    return this.get('histogram').toJS();
  }

  getAllowedDateRange() {
    return this.get('allowedDateRange').toJS();
  }

  getGuideDelivery() {
    return this.get('guideDelivery');
  }

  histogramLoaded() {
    return this.get('loaded');
  }

  rehydrate(state) {
    state.histogram.forEach(e => {
      e.timestamp = new Date(e.timestamp);
    });
    state.allowedDateRange.start = new Date(state.allowedDateRange.start);
    state.allowedDateRange.end = new Date(state.allowedDateRange.end);
    super.rehydrate(state);
  }
}

export default HistogramStore;



// WEBPACK FOOTER //
// ./src/stores/HistogramStore.js